import GTMMapping from './GTMMapping';
import NissanGTMMapping from './NissanGTMMapping';

export default {
	NissanGTMMapping,
	GTMMapping
};
